// Version file to track builds
export const BUILD_VERSION = new Date().toISOString();
export const BUILD_NUMBER = Math.random().toString(36).substr(2, 9);

console.log('Frontend build version:', BUILD_VERSION, BUILD_NUMBER);